/** Called only after the foundation redaction check. ISO dates are formatted without changing their day.
 * D12 (1.11) : `long` = Intl dateStyle long (« 7 octobre 2028 », « October 7, 2028 »), dans la locale de l'utilisateur. */
export type TemplateDateStyle='medium'|'long';
export function templateDate(value:unknown,locale:string,style?:TemplateDateStyle):string|null {
 if(typeof value!=='string'||!/^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2}))?$/.test(value))return null;
 const date=new Date(value.length===10?value+'T00:00:00Z':value);
 if(!Number.isFinite(date.getTime()))return null;
 if(style==='long')return new Intl.DateTimeFormat(locale,{dateStyle:'long',timeZone:'UTC'}).format(date);
 return new Intl.DateTimeFormat(locale,{year:'numeric',month:style==='medium'?'short':'2-digit',day:'2-digit',timeZone:'UTC'}).format(date);
}
